import { WbTooltip } from '../WbTooltip';
import { FC, MouseEventHandler } from 'react';
import { WbButton } from '../WbButton';
import { CollapseDockablePanelIcon, ExpandDockablePanelIcon } from './icons';

interface Props {
  onClick?: MouseEventHandler<HTMLElement>;
}

export const CollapseButton: FC<Props> = ({ onClick }) => {
  return (
    <WbTooltip title="Collapse">
      <span>
        <WbButton
          icon={<CollapseDockablePanelIcon style={{ fontSize: 14 }} />}
          aria-label="Collapse"
          aria-expanded
          variant="text"
          color="inherit"
          onClick={onClick}
          style={{
            padding: '8px',
            height: '100%',
            minWidth: 0,
          }}
        />
      </span>
    </WbTooltip>
  );
};

interface ExpandButtonProps {
  onClick?: MouseEventHandler<HTMLElement>;
  ariaLabel: string;
}

export const ExpandButton: FC<ExpandButtonProps> = ({ onClick, ariaLabel }) => {
  return (
    <WbTooltip title={ariaLabel}>
      <WbButton
        icon={<ExpandDockablePanelIcon style={{ fontSize: 14 }} />}
        aria-label={ariaLabel}
        aria-expanded={false}
        variant="text"
        onClick={onClick}
        color="inherit"
        style={{
          padding: '8px',
          height: '100%',
          width: '100%',
          minWidth: 0,
          marginTop: '12px',
        }}
      />
    </WbTooltip>
  );
};
